import { createElement, Component } from 'react';
import { number, func, string } from 'prop-types';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_lv-pagination__3ZIXX {\n  font-size: 12px;\n  font-family: \"Arial\";\n  user-select: none;\n  padding: 0;\n}\n.styles_lv-pagination__3ZIXX > li {\n  list-style: none;\n}\n.styles_lv-pagination-item__1RzBO {\n  cursor: pointer;\n  border-radius: 6px;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n  list-style: none;\n  float: left;\n  border: 1px solid #d9d9d9;\n  background: #fff;\n  margin-right: 8px;\n}\n.styles_lv-pagination-item__1RzBO a {\n  text-decoration: none;\n  color: #666;\n}\n.styles_lv-pagination-item__1RzBO:hover {\n  border-color: #2db7f5;\n}\n.styles_lv-pagination-item__1RzBO:hover a {\n  color: #2db7f5;\n}\n.styles_lv-pagination-item-active__1f7tw {\n  background-color: #2db7f5;\n  border-color: #2db7f5;\n}\n.styles_lv-pagination-item-active__1f7tw a {\n  color: #fff;\n}\n.styles_lv-pagination-item-active__1f7tw:hover a {\n  color: #fff;\n}\n.styles_lv-pagination-disabled__ZnGXF {\n  cursor: not-allowed;\n}\n.styles_lv-pagination-disabled__ZnGXF a {\n  color: #ccc;\n}\n.styles_lv-pagination-prev__2o_9o a:after {\n  content: \"\\2039\";\n  display: block;\n}\n.styles_lv-pagination-next__1eUKQ a:after {\n  content: \"\\203A\";\n  display: block;\n}\n";
var styles = {"lv-pagination":"styles_lv-pagination__3ZIXX","lv-pagination-item":"styles_lv-pagination-item__1RzBO","lv-pagination-item-active":"styles_lv-pagination-item-active__1f7tw","lv-pagination-disabled":"styles_lv-pagination-disabled__ZnGXF","lv-pagination-prev":"styles_lv-pagination-prev__2o_9o","lv-pagination-next":"styles_lv-pagination-next__1eUKQ"};
styleInject(css);

var Pager = function (props) {
    var prefixCls = props.rootPrefixCls + "-item";
    var cls = "" + styles[prefixCls];
    if (props.active) {
        cls = cls + " " + styles[prefixCls + '-active'];
    }
    var handleClick = function () {
        props.onClick(props.page);
    };
    return (createElement("li", { onClick: handleClick, className: cls },
        createElement("a", null, props.page)));
};
//# sourceMappingURL=Pager.js.map

function noop() { }
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.isValid = function (page) {
            return typeof page === 'number' && page >= 1 && page !== _this.state.current;
        };
        _this.calcPage = function () {
            return Math.floor((_this.props.total - 1) / _this.state.pageSize) + 1;
        };
        _this.handleChange = function (page) {
            if (_this.isValid(page)) {
                _this.setState({ current: page });
                _this
                    .props
                    .onChange(page);
            }
        };
        _this.prev = function () {
            if (_this.hasPrev()) {
                _this.handleChange(_this.state.current - 1);
            }
        };
        _this.next = function () {
            if (_this.hasNext()) {
                _this.handleChange(_this.state.current + 1);
            }
        };
        _this.hasPrev = function () {
            return _this.state.current > 1;
        };
        _this.hasNext = function () {
            return _this.state.current < _this.calcPage();
        };
        _this.state = {
            current: props.current,
            pageSize: props.pageSize
        };
        return _this;
    }
    Pagination.prototype.render = function () {
        var props = this.props;
        var prefixCls = props.prefixCls;
        var pagerList = [];
        var allPage = this.calcPage();
        if (allPage <= 9) {
            for (var i = 0; i <= allPage; i++) {
                pagerList.push(createElement(Pager, { key: i, page: i, onClick: this.handleChange, rootPrefixCls: prefixCls, active: this.state.current === i }));
            }
        }
        return (createElement("ul", { className: styles[prefixCls] + " " + props.className },
            createElement("li", { onClick: this.prev, className: (this.hasPrev()
                    ? ''
                    : styles[prefixCls + "-disabled"]) + ' ' + styles[prefixCls + "-prev"] },
                createElement("a", null)),
            pagerList,
            createElement("li", { onClick: this.next, className: (this.hasPrev()
                    ? ''
                    : styles[prefixCls + "-disabled"]) + ' ' + styles[prefixCls + "-next"] },
                createElement("a", null))));
    };
    Pagination.propTypes = {
        total: number,
        current: number,
        pageSize: number,
        onChange: func,
        prefixCls: string,
        className: string
    };
    Pagination.defaultProps = {
        total: 0,
        pageSize: 10,
        current: 1,
        onChange: noop,
        prefixCls: 'lv-pagination',
        className: ''
    };
    return Pagination;
}(Component));
//# sourceMappingURL=index.js.map

export default Pagination;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 20
// module chunks = 0